/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';

import classNames from 'classnames';

import TextInput from '../TextInput';

import classes from './styles.module.css';

export default function Checkbox({
  label,
  value,
  onChange,
  onBlur,
  tabindex,
  name,
  style,
  disabled,
  readOnly,
}) {
  // If the checkbox is read only, display the value as a text input
  if (readOnly) {
    return <TextInput value={value ? 'Yes' : 'No'} readOnly label={label} />;
  }

  return (
    <div style={style}>
      <label className="flex md:flex-col-reverse items-center md:items-start md:gap-3">
        <input
          type="checkbox"
          className={classNames('form-checkbox', classes.checkbox)}
          name={name}
          checked={value}
          onChange={onChange}
          onBlur={onBlur}
          tabIndex={tabindex}
          disabled={disabled}
        />
        <span className="text-sm ml-2 md:ml-0 font-medium">{label}</span>
      </label>
    </div>
  );
}
